import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import "./profilePages.scss";

function WelcomePage() {
  const navigate = useNavigate();

  return (
    <div className="welcomePage">
      <div className="message">Welcome to Speqqle!</div>
      <div className="messageSmall">
        Thank you for registering, to continue please click on the confirmation
        link in the email we have sent to you.
        <br />
        If you have not received the email, please check your spam folder or
        contact us at{" "}
        <a href="mailto:support@speqqle.com">support@speqqle.com</a>.
      </div>
      <div className="login">
        <Button
          variant="contained"
          className="loginButton"
          onClick={() => navigate("/login")}
        >
          Login
        </Button>
      </div>
    </div>
  );
}

export default WelcomePage;
